import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import ContactForm from '@/components/ContactForm';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { links, pages } from '@/content';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import Markdown from 'react-markdown';
import page from '@/graphql/queries/page';
import { REVALIDATE_TIME_IN_SEC } from '@/constants/env';

export default function ContactPage({ page, mainLayout }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      <BreadcrumbsBlock items={[pages.home, pages.contact]} />
      <motion.section
        className="my-16 px-4"
        initial="hidden"
        transition={fadeInUp.transition}
        variants={fadeInUp}
        viewport={fadeInUp.viewport}
        whileInView="visible"
      >
        <div className="container-screen">
          <div className="flex items-center lg:ml-auto lg:w-1/2 lg:justify-center">
            <h1 className="text-3xl font-medium lg:text-4xl">{attributes.shortName || ''}</h1>
          </div>
        </div>
      </motion.section>
      <motion.section
        className="mt-16 bg-primary-500/10 px-4"
        initial="hidden"
        transition={{
          ...fadeIn.transition,
          when: 'beforeChildren',
          staggerChildren: 0.4,
        }}
        variants={fadeIn}
        viewport={fadeIn.viewport}
        whileInView="visible"
      >
        <div className="container-screen grid gap-8 py-12 lg:grid-cols-2">
          <motion.div
            className="-mt-20 rounded-lg bg-white p-4 text-neutral-700 shadow-lg ring-1 ring-neutral-100 lg:-mt-44 lg:p-8"
            variants={fadeInUp}
          >
            <ContactForm />
          </motion.div>
          <motion.div variants={fadeInUp}>
            <div className="grid grid-cols-2 gap-4">
              {/* <div>
                <h4 className="lg:text-xl">E-mail:</h4>
                <p className="font-light lg:text-xl">info@ceadnv.com</p>
              </div>
              <div>
                <h4 className="lg:text-xl">Address:</h4>
                <ul className="font-light lg:text-xl">
                  <li>
                    <a
                      className="text-primary-500 hover:underline"
                      href="https://goo.gl/maps/cBPPCQsi248H5e1HA"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Plutostraat 108
                    </a>
                  </li>
                  <li>Paramaribo, Suriname</li>
                  <li>South America</li>
                </ul>
              </div>
              <div>
                <h4 className="lg:text-xl">Telephone:</h4>
                <ul className="font-light lg:text-xl">
                  <li>+597-459070</li>
                  <li>+1-7866971099</li>
                </ul>
              </div> 
               <div>
                <h4 className="lg:text-xl">Social Media:</h4>
                <div className="flex items-center gap-2">
                  <a
                    className="text-[#4267B2]"
                    href={links.facebook}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Icon height="36" icon="fa-brands:facebook-square" />
                  </a>
                  <a
                    className="text-[#0077B5]"
                    href={links.linkedIn}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Icon height="36" icon="fa-brands:linkedin" />
                  </a>
                </div>
              </div> */}

              {(contentSection || []).map((item, i) => (
                <div key={i}>
                  <h4 className="lg:text-xl">{item.contactTitle}</h4>
                  {item.__typename == 'ComponentComponentsTitleEditor' ? (
                    <div className="font-light lg:text-xl">
                      <Markdown>{item.content}</Markdown>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      {(item.links || []).map((link, i) => (
                        <a
                          key={i}
                          className="text-[#4267B2]"
                          href={link.url}
                          rel="noreferrer"
                          target="_blank"
                        >
                          <Icon height="36" icon={link.icon} />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </motion.section>
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(page, { slug: 'contact' });

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
